import axiosInstance from "./axiosInstance";

class ConfigService {
    static async getConfigByKey(key: string): Promise<any | undefined> {
        try {
            const response = await axiosInstance.get<
                ApiResponse<ConfigResponse>
            >(`/config?key=${key}`);

            return Promise.resolve(response.data.result);
        } catch (error) {
            throw error;
        }
    }
}

export default ConfigService;
